<template>
  <!--
      作者：kmdshop
      时间：2024-6-17
      描述：插件中心-进销存管理-编辑
    -->
    <el-dialog
    title="同步产品"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >
      <div class="product-add pb50" v-loading="loading">
        <!--编辑文章-->
        <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
          <div class="common-form">同步</div>
           
  

            <el-form-item label="同步产品价格" prop="sync_price">
               <el-checkbox v-model="search.sync_price" ></el-checkbox>

               <span v-if="search.sync_price" >同步后价格:{{ form.price }}</span>
            </el-form-item>   

            <el-form-item label="同步库存" prop="sync_stock">
               <el-checkbox v-model="search.sync_stock" ></el-checkbox>

               
            </el-form-item>   

            <el-form-item v-if="search.sync_stock" label="同步库存模式" prop="sync_stock">
           
               <el-radio-group v-model="search.sync_stock_type">
                <el-radio :label="10">叠加</el-radio>
                <el-radio :label="20">覆盖</el-radio>

        
              </el-radio-group>
              <div>
                  叠加:叠加积分
                  覆盖:覆盖原有积分
                </div>
            </el-form-item>  
            
          

            <!-- 如果商品不存在，可不用勾选 -->
            <div>
              如果商品不存在，可不用勾选。不同步则采用现有商品的数据；
              同步完成后，不再支持同步
            </div>
          <!--提交-->
          <div class="common-button-wrapper">
            <el-button size="small" type="info" @click="cancelFunc" :loading="loading">取消</el-button>
            <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
</template>

<script>
import PsinApi from '@/api/psin.js';
export default {
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*form表单数据*/
      search:{
        sync_price:false,
        sync_stock:false,
        sync_stock_type:10,
      },
      form: {
        price: 0,
      
      },

      /*验证规则*/
      rules: {
   
      }
    };
  },
  props: ["open_psin","id"],
  created() {
    this.dialogVisible = this.open_psin;
    this.getDetail();
    this.loading = false;

  },

  methods: {
      /*关闭弹窗*/
      dialogFormVisible() {
      this.$emit("close", {});
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },
    getDetail() {
      let self = this;
      // 取到路由带过来的参数
      const params = self.id;
      PsinApi.detail({id: params},true).then(res => {
          self.form = res.data;
          self.loading = false;
        })
        .catch(error => {});
    },

    /*修改任务*/
    onSubmit() {
      let self = this;
      let params = this.search;
      params.psin_id =  self.id;

      self.loading = true;
      PsinApi.syncProduct(params, true)
        .then(data => {
                   self.$message({
            message: data.msg,
            type: 'success'
          });
          this.cancelFunc();
    
        })
        .catch(error => {
          self.loading = false;
        });

    },
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/plus/psin/index/sync.vue